/**
 * Main persistent/state storage for dashboard
 *
 *  - teamFilterAtom: array of team ids
 *  - questionFilterAtom: array of question ids
 *  - dateFilterAtom: object with from and to dates
 *  - locationFilterAtom: array of location ids, this is the Google place id's
 *  - generalFilterAtom: object with source and format arrays
 *
 * To use:
 *  import { teamFilterAtom } from '@/Stores';
 *  ...inside component...
 *  const [teamFilter, setTeamFilter] = useAtom(teamFilterAtom);
 */
import {
  atomWithLocalStorage,
  generateDefaultDatespan,
} from "@/Utilities/Utilities";

export const teamFilterAtom = atomWithLocalStorage(
  "dashboard/teamFilterAtom",
  null,
);

export const questionFilterAtom = atomWithLocalStorage(
  "dashboard/questionFilterAtom",
  null,
);
export const dateFilterAtom = atomWithLocalStorage(
  "dashboard/dateFilterAtom",
  generateDefaultDatespan(),
  60 * 60 * 24 * 7,
);
export const locationFilterAtom = atomWithLocalStorage(
  "dashboard/locationFilterAtom",
  null,
);
export const generalFilterAtom = atomWithLocalStorage(
  "dashboard/generalFilterAtom",
  {
    source: [],
    format: ["ar5"],
    reports: "all",
  },
);

export const dashboardTagFilterAtom = atomWithLocalStorage(
  "dashboard/tagFilterAtom",
  null,
);

export const dashboardSortAtom = atomWithLocalStorage(
  "dashboard/sortAtom",
  "title.asc",
);
